import { LookupBase } from '../../models/utils/lookup-base.model';

export enum DocumentWriteAction {
  create = 'create',
  update = 'update',
  remove = 'remove',
}

export const DOCUMENT_WRITE_ACTION_LOOKUP: LookupBase[] = [
  { value: DocumentWriteAction.create, description: 'Create' },
  { value: DocumentWriteAction.update, description: 'Update' },
  { value: DocumentWriteAction.remove, description: 'Remove' },
];
